import { trackEvent } from '@99designs/tracking';

const trackRecommendationsViewed = (location: string, bannerType: 'generic' | 'personalized') => {
    trackEvent('Viewed VistaPrint Recommendations Banner', {
        location,
        bannerType,
    });
};

const trackRecommendationsItemClicked = (
    location: string,
    targetUrl: string,
    targetProduct: string,
    bannerType: 'generic' | 'personalized'
) => {
    trackEvent('Clicked VistaPrint Recommendations Banner', {
        location,
        target_url: targetUrl,
        target_product: targetProduct,
        bannerType,
    });
};

const trackRecommendationsDismissed = (location: string) => {
    trackEvent('Dismissed VistaPrint Recommendations Banner', {
        location,
    });
};

const trackSwapLogoButton = (location: string) => {
    trackEvent('Clicked VistaPrint Recommendations Banner Swap Logo File Button', {
        location,
    });
};

const trackLogoFileSwapped = (location: string) => {
    trackEvent('Selected VistaPrint Recommendations Banner Swap Logo File', {
        location,
    });
};

export default {
    trackRecommendationsViewed,
    trackRecommendationsDismissed,
    trackRecommendationsItemClicked,
    trackSwapLogoButton,
    trackLogoFileSwapped,
};
